var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo, useCallback } from 'react';
import { styled } from 'styled-components';
import { DatePicker } from '@hn-ui/datepickers';
import { dropdownItemsNoTBDFull } from '@hn-front/data-types';
import { BlueButton } from '@hn-ui/buttons';
import { useToggle } from '@hn-front/utils';
import { parseISO } from 'date-fns';
import { Text } from '../../Common';
import { nextWeekDate } from '../../utils';
import { GradeDropdown } from '../../GradeDropdown';
import { ConfirmEditModal } from './ConfirmEditModal';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-r1ww29" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  padding: 24px 0;\n"], ["\n  display: flex;\n  flex-flow: column;\n  padding: 24px 0;\n"])));
var InputContainer = styled.div.withConfig({ displayName: "InputContainer", componentId: "sc-1tbogiw" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  margin: 24px 0;\n"], ["\n  display: flex;\n  margin: 24px 0;\n"])));
var GradesDropdownChecklist = styled(GradeDropdown).withConfig({ displayName: "GradesDropdownChecklist", componentId: "sc-179hhgt" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 24px;\n"], ["\n  margin-left: 24px;\n"])));
var EditSection = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, onSave = _a.onSave, grades = _a.grades, rest = __rest(_a, ["startDate", "endDate", "onSave", "grades"]);
    var _b = useToggle(), isEditOpen = _b.isToggled, toggleEdit = _b.toggle;
    var _c = useMemo(function () { return ({ start: parseISO(startDate), end: parseISO(endDate) }); }, [startDate, endDate]), start = _c.start, end = _c.end;
    var gradeItems = useMemo(function () {
        return dropdownItemsNoTBDFull
            .filter(function (item) { return grades.includes(item.value); })
            .map(function (item) { return (__assign(__assign({}, item), { disabled: true })); });
    }, [grades]);
    var _d = useState([start, end]), dates = _d[0], setDates = _d[1];
    var _e = useState(gradeItems), currentGradeItems = _e[0], setCurrentGradeItems = _e[1];
    var handleOnSave = useCallback(function () {
        var gradeValues = currentGradeItems
            .filter(function (g) { return g.value !== -100; })
            .map(function (g) { return g.value; });
        onSave(gradeValues);
        toggleEdit();
    }, [onSave, currentGradeItems, toggleEdit]);
    var dirtyGrades = currentGradeItems
        .filter(function (g) { return g.value !== -100 && !grades.includes(g.value); })
        .map(function (g) { return g.value; });
    var isFormInvalid = !dates || dirtyGrades.length === 0;
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(Text, { children: "Add additional grade(s) that will participate in the challenge." }, void 0), _jsxs(InputContainer, { children: [_jsx(DatePicker, { label: 'Select start week', onChange: setDates, type: 'range', minDate: nextWeekDate, startDate: start, endDate: end, disabled: true, popperPlacement: 'bottom-start' }, void 0), _jsx(GradesDropdownChecklist, { values: currentGradeItems, onChange: setCurrentGradeItems }, void 0)] }, void 0), _jsx(BlueButton, __assign({ fit: true, onClick: toggleEdit, disabled: isFormInvalid }, { children: "Save challenge" }), void 0), _jsx(ConfirmEditModal, { isOpen: isEditOpen, onSave: handleOnSave, onCancel: toggleEdit, grades: dirtyGrades }, void 0)] }), void 0));
};
export { EditSection };
var templateObject_1, templateObject_2, templateObject_3;
